import { createContext } from "react"
import { Center, Spinner } from '@chakra-ui/react'
import { gql } from "@apollo/client"
import { ErrComp } from "../ErrCompF.jsx"

export const CenteredSpinnerBase = (props) => {
  return <Center {...{width: '100%', ...props}} >
    <Spinner {...{size: 'xl'}} />
  </Center>
}

export const CenterSpinnerFull = (props) => {
  return <CenteredSpinnerBase {...{h: '100%', ...props}} />
}

export const MkGetUserFromTokQuery = (fieldNames) => {
  return gql`query ($gqUserTok: String!) {
  gqUserFromToken(gqUserTok: $gqUserTok) {
    ${fieldNames.join(', ')}
  }
}`
}

export const BareGetUserFromTokQuery = MkGetUserFromTokQuery(['email'])

export const defaultSiteCtx = {
  genericErrMsg: 'Error please try again later',
  UserAuthQuery: BareGetUserFromTokQuery,
  LoadingComp: CenteredSpinnerBase,
  ErrComp,
  fmtSiteError: ({error}) => {
    return `Error: ${error.message}`
  },
}

export const PtSiteCtx = createContext(defaultSiteCtx)
